import React from "react";
import {
  FaBookOpen,
  FaChalkboardTeacher,
  FaBuilding,
  FaHandshake,
  FaCheckCircle,
} from "react-icons/fa";

const WhyChooseSection = () => {
  const features = [
    {
      icon: <FaBookOpen className="h-7 w-7" />,
      title: "Industry Aligned Curriculum",
      description:
        "Courses designed with input from industry experts to ensure students gain relevant, job‑ready skills.",
      color: "green",
    },
    {
      icon: <FaChalkboardTeacher className="h-7 w-7" />,
      title: "Experienced Faculty",
      description:
        "Learn from certified instructors with years of industry and teaching experience.",
      color: "orange",
    },
    {
      icon: <FaBuilding className="h-7 w-7" />,
      title: "Modern Infrastructure",
      description:
        "State‑of‑the‑art workshops, labs, and classrooms for hands‑on training.",
      color: "green",
    },
    {
      icon: <FaHandshake className="h-7 w-7" />,
      title: "100% Placement Assistance",
      description:
        "Dedicated placement cell to help students secure jobs in reputed companies.",
      color: "orange",
    },
  ];

  return (
    <section className="w-full overflow-hidden bg-gradient-to-br from-green-50 via-white to-orange-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12 text-center">
          <div className="inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 shadow-md">
            <FaCheckCircle className="h-5 w-5 text-green-600" />
            <span className="text-sm font-semibold text-gray-700">Why Choose Us</span>
          </div>
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900 md:text-4xl">
            Why Choose <span className="text-green-600">Sharda ITI?</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-gray-600 md:text-lg">
            We provide the best environment for technical education and career growth
          </p>
        </div>
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="group relative rounded-2xl bg-white p-6 shadow-md transition-all duration-300 hover:shadow-xl hover:-translate-y-2"
            >
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-green-500 to-orange-500 opacity-0 transition-opacity duration-300 group-hover:opacity-100 -z-10 blur-sm"></div>
              <div className="absolute inset-[1px] rounded-2xl bg-white transition-all duration-300"></div>
              
              <div className="relative z-10">
                <div
                  className={`mb-5 flex h-14 w-14 items-center justify-center rounded-xl ${
                    feature.color === "green"
                      ? "bg-green-100 text-green-600 group-hover:bg-green-600 group-hover:text-white"
                      : "bg-orange-100 text-orange-500 group-hover:bg-orange-500 group-hover:text-white"
                  } transition-colors duration-300`}
                >
                  {feature.icon}
                </div>
                <h3 className="mb-2 text-xl font-bold text-gray-800">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-16 grid grid-cols-2 gap-4 rounded-2xl bg-white/60 p-6 backdrop-blur-sm shadow-md md:grid-cols-4">
          <div className="text-center">
            <p className="text-2xl font-bold text-green-600">12+</p>
            <p className="text-sm text-gray-600">Years of Excellence</p>
          </div>
          <div className="text-center">
            <p className="text-2xl font-bold text-orange-500">1000+</p>
            <p className="text-sm text-gray-600">Students Trained</p>
          </div>
          <div className="text-center">
            <p className="text-2xl font-bold text-green-600">95%</p>
            <p className="text-sm text-gray-600">Placement Rate</p>
          </div>
          <div className="text-center">
            <p className="text-2xl font-bold text-orange-500">20+</p>
            <p className="text-sm text-gray-600">Industry Partners</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;